/**
 * Automation Rule Type Definitions.
 */

export interface AutomationRule {
  id: string;
  organization_id: string;
  name: string;
  description: string | null;
  is_active: boolean;
  trigger_entity_type: string;
  trigger_event: string;
  trigger_conditions: Record<string, unknown>;
  action_type: string;
  action_config: Record<string, unknown>;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface AutomationRuleCreate {
  name: string;
  description?: string;
  trigger_entity_type: string;
  trigger_event: string;
  trigger_conditions?: Record<string, unknown>;
  action_type: string;
  action_config?: Record<string, unknown>;
}

export const TRIGGER_ENTITY_TYPES = [
  { value: "asset", label: "Asset" },
  { value: "purchase_order", label: "Purchase Order" },
  { value: "work_order", label: "Work Order" },
  { value: "sales_order", label: "Sales Order" },
] as const;

export const TRIGGER_EVENTS = [
  { value: "status_changed", label: "Status Changed" },
  { value: "created", label: "Created" },
] as const;

export const ACTION_TYPES = [
  { value: "create_work_order", label: "Create Work Order" },
  {
    value: "create_wo_from_template",
    label: "Create Work Order from Template",
  },
  { value: "update_status", label: "Update Status" },
] as const;

// ASSET_STATUSES lived here: a second hardcoded copy of the twenty-two seeded
// lifecycle statuses (FS-015). FS-029 deleted the first copy — a thirteen-name
// array in the inventory filter that no tenant's configured lifecycle
// necessarily matched. This one was the same defect in the automation builder:
// a tenant that renamed or extended its statuses was offered names that did not
// exist, and never offered the ones that did. Use `useStatuses("asset")`, which
// reads the organization's own.
